/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { StyledText } from "../../assets/typography/typography";

const bannerStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 16px 16px;
  background-color: #a55eea;
  color: #fff;
  font-size: 14px;
  text-align: center;
  text-decoration: none;

  &:hover {
    color: #fff;
    text-decoration: none;
    opacity: 0.9;
  }

  span {
    font-weight: 600;
    text-decoration: underline;
  }
`;

export const NewAdminBanner = () => {
  return (
    <a
      css={bannerStyle}
      href="https://admin.heapsgo.com"
      target="_blank"
      rel="noreferrer"
    >
      <StyledText className="bodyTextRegular mb-0">
        A new admin dashboard is available. <span>Go to the new admin →</span>
      </StyledText>
    </a>
  );
};
